/*
 * サブシステム名：OTM受付一覧編集
 * 機能名：受付一覧編集
 */
import flowMixin from '@/mixins/flowMixins'
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'

import filter from '@/rahmen/utils/filters'
import date from '@/ddv2.library/date'
import header from '@/ddv2.library/header'

// import { mapGetters } from 'vuex'
import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'
import DdSpreadSheet from '@/components/DdSpreadSheet'
const DdCheckbox = () => import('@/components/DdCheckbox')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox.vue')
const DdDateBox = () => import('@/components/DdDateBox')
const DdDropDown = () => import('@/components/DdDropDown')
const DdEditCommonBar = () => import('@/components/DdEditCommonBar')
const DdNumericBox = () => import('@/components/DdNumericBox')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdSwitch = () => import('@/components/DdSwitch')
const DdTimeBox = () => import('@/components/DdTimeBox')
const DdTimeRangeBox = () => import('@/components/DdTimeRangeBox')
const DdTextArea = () => import('@/components/DdTextArea')

export default {
  name: 'OtmScheduler',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdSpreadSheet,
    DdCheckbox,
    DdCodeTextBox,
    DdDateBox,
    DdDropDown,
    DdEditCommonBar,
    DdNumericBox,
    DdSubHeader,
    DdSwitch,
    DdTimeBox,
    DdTimeRangeBox,
    DdTextArea
  },
  data: () => ({
    id: null,
    viewTitleX: '労務管理(Ver.Xls)',
    viewsData: {
      vwUnkoJisseki: {},
      vwKinmuJisseki: {},
      vwKintaiJisseki: [],
      vwManageInfo: {}
    },
    baseYmd: null,

    // 内部処理用
    targetCountLists: [1, 2, 3, 4, 5],
    weekDayStrJP: ['日', '月', '火', '水', '木', '金', '土'],

    // ----------------------------------------------------------------------------------------------------
    // オートコンプリート定義
    // ----------------------------------------------------------------------------------------------------
    mstJininHeaders: header.mstJininHeaders,
    mstSharyoHeaders: header.vwCMstSharyoHeaders,

    // 制御用
    modeKengen: 0,

    // スプレッドシートオプション
    option: {
      // テーブル最大高さ
      tableHeight: '60vh',
      // テーブル最大横幅
      tableWidth: 'inherit',
      // 列追加
      allowInsertColumn: false,
      // 行追加※改行キーのみ
      allowManualInsertRow: false,
      // 列削除
      allowDeleteColumn: false,
      // 行削除
      allowDeleteRow: false,
      // 列ドラッグ
      columnDrag: false,
      // 行ドラッグ
      rowDrag: false,
      // ソート
      columnSorting: true,
      // スクロール有効化
      tableOverflow: true,
      // コンテキストメニュー
      contextmenu: false,
      // セル内HTML無効※ヘッダー改行のため有効
      stripHTML: false,
      // 計算式のサポート
      parseFormulas: true,
      // セル選択時の右下の■ドラッグでのコピー
      selectionCopy: false,
      // CSV出力
      allowExport: false,
      // フィルターオプション
      search: false,
      // ページネーションオプション
      pagination: 25,
      paginationOptions: [10, 25, 50, 100],
      // デフォルト文言変更
      text: {
        show: '1ページ当たりの行数:',
        entries: '',
        showingPage: '全部で {1} ページあります',
        search: 'さらにフリーワードで絞り込む',
        noRecordsFound: '対象データがありません'
      }
    },
    // 画面側からのエラーリスト
    outsideErrorList: []
  }),
  watch: {
    conditions: {
      handler: function (s) {
        if (![undefined, null, ''].includes(s.baseYmd)) {
          this.setShowTarget()
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'users/helpUseFlg',
      eigyoshoJininList: 'DDMasters/vwCMstEigyoshoJininList',
      sharyoList: 'DDMasters/vwCMstSharyo',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg'
    }),

    // 人員マスタフィルタ
    filteredVwcMstJinin () {
      return this.eigyoshoJininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredJishaJininList () {
      const self = this
      return this.filteredVwcMstJinin.filter((t) => {
        return t.tekiyoStartYmdDisp <= self.baseYmd && t.tekiyoEndYmdDisp >= self.baseYmd && t.eigyoshoKbn !== '03'
      })
    },

    // 車両マスタフィルタ
    filteredMstSharyo () {
      return this.sharyoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredMstSharyoList () {
      const self = this
      return this.filteredMstSharyo.filter((t) => {
        return t.tekiyoStartYmdDisp <= self.baseYmd && t.tekiyoEndYmdDisp >= self.baseYmd && t.hacchusakiFlg === false
      })
    },

    // 作業種別
    filteredSagyoSbtList () {
      var itemList = []
      itemList.push({ value: null, text: '未選択' })
      itemList.push({ value: '01', text: '運転手' })
      itemList.push({ value: '02', text: '作業員' })
      return itemList
    },
    filteredKasanJikyuSbtList () {
      var itemList = []
      return itemList
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  methods: {
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['vwcmsteigyoshojininlist', 'vwcmstsharyo'],
        defineHeaderPromise: () => {
          return new Promise((resolve) => {
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initSettings()
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          return new Promise((resolve) => {
            resolve()
          })
        },
        researchPromise: (c) => {
          console.log('OtmDeliveryLedger.researchPromise', c)
          return new Promise(resolve => {
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('OtmDeliveryLedger.restoreViewPromise', c)
          return new Promise(resolve => {
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('OtmDeliveryLedger.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    initSettings: function () {
      this.setHeader().then(x => {
      })
      this.id = 0
      this.baseYmd = date.getCurrentDate()
      this.viewsData.vwUnkoJisseki.unkoYmd = this.baseYmd
      this.viewsData.vwKinmuJisseki.shukkoYmd = this.baseYmd

      this.viewsData.vwKintaiJisseki.push(
        { id: 1, sagyoKbn: '01', sagyoKbnNm: '運転手', jininId: null, shukkinHms: null, taikinHms: null },
        { id: 2, sagyoKbn: '02', sagyoKbnNm: '作業員', jininId: null, shukkinHms: null, taikinHms: null }
      )
      this.viewsData.vwKintaiJisseki.forEach((elem, index) => {
        const y = index + 1
        elem.kosokuTimeFormula = `=IF(OR(H${y}="",G${y}=""),"",TEXT(TIMEVALUE(H${y})-TIMEVALUE(G${y}), "HH:mm"))`
        elem.kadoTimeFormula = `=IF(OR(H${y}="",G${y}=""),"",TEXT(TIMEVALUE(H${y})-TIMEVALUE(G${y})-IF(I${y}="",0,TIMEVALUE(I${y})), "HH:mm"))`
      })
    },

    /**
     * ボタンイベント
     */
    onReturnButtonClick: function () {
    },
    onAddTantoshaClick: function () {
      const tmp = {
        sagyoKbn: null,
        sagyoKbnNm: null,
        jininId: null,
        shukkinHms: null,
        taikinHms: null
      }
      this.viewsData.vwKintaiJisseki.push(tmp)
      this.viewsData.vwKintaiJisseki.splice()
    },

    getWeekDay: function (d) {
      var dx = dayjs(d)
      return '(' + this.weekDayStrJP[dx.day()] + ')'
    },

    /**
     * スプレッドシート制御
     * @returns
     */
    setHeader: function () {
      console.log('setHeader')
      const self = this
      return new Promise(resolve => {
        var wkSagyoKbnList = []
        wkSagyoKbnList.push('運転手')
        wkSagyoKbnList.push('作業員')

        var wkKasanJikyuKbnList = []

        self.headers = [
          { title: '担当者', name: 'sagyoTantoshaNm', type: 'text', validateType: 'Free', validateLength: 50, required: false, readOnly: false, width: '150px' },
          { title: '作業区分', name: 'sagyoKbnNm', type: 'dropdown', source: wkSagyoKbnList, required: false, readOnly: false, width: '100px', autocomplete: true },
          { title: '変則業務', name: 'hensokuGyomuFlg', type: 'checkbox', validateType: 'Free', validateLength: 50, required: false, readOnly: false, width: '90px' },
          { title: '集計対象外', name: 'shukeiTaishogaiFlg', type: 'checkbox', validateType: 'Free', validateLength: 50, required: false, readOnly: false, width: '90px' },
          { title: '個人デジタコ点数', name: 'digitakoPoint', type: 'numeric', validateIntDigit: 3, validateDecimalDigit: 0, readOnly: false, align: 'right', width: '120px', mask: '##0' },
          { title: '加算自給区分', name: 'kasanJikyuKbnNm', type: 'dropdown', source: wkKasanJikyuKbnList, required: false, readOnly: false, width: '100px', autocomplete: true },
          { title: '出勤時刻', name: 'shukkinTime', type: 'text', source: wkKasanJikyuKbnList, required: false, readOnly: false, width: '80px', align: 'center', validateType: 'Time' },
          { title: '退勤時刻', name: 'taikinTime', type: 'text', source: wkKasanJikyuKbnList, required: false, readOnly: false, width: '80px', align: 'center', validateType: 'Time' },
          { title: '休憩時間', name: 'kyukeiTime', type: 'text', source: wkKasanJikyuKbnList, required: false, readOnly: false, width: '80px', align: 'center', validateType: 'TimeSpan' },
          { title: '内深夜早朝分', name: 'shinyaTime', type: 'text', source: wkKasanJikyuKbnList, required: false, readOnly: false, width: '100px', align: 'center', validateType: 'TimeSpan' },
          { title: '内休憩中作業', name: 'kyukeichuSagyoTime', type: 'text', source: wkKasanJikyuKbnList, required: false, readOnly: false, width: '100px', align: 'center', validateType: 'TimeSpan' },
          { title: '出庫前作業', name: 'shukkoMaeSagyoTime', type: 'text', source: wkKasanJikyuKbnList, required: false, readOnly: false, width: '90px', align: 'center', validateType: 'TimeSpan' },
          { title: '出庫後作業', name: 'shukkoAtoSagyoTime', type: 'text', source: wkKasanJikyuKbnList, required: false, readOnly: false, width: '90px', align: 'center', validateType: 'TimeSpan' },
          { title: '拘束時間', name: 'kosokuTimeFormula', type: 'text', source: wkKasanJikyuKbnList, required: false, readOnly: true, width: '80px', align: 'center' },
          { title: '労働時間', name: 'kadoTimeFormula', type: 'text', source: wkKasanJikyuKbnList, required: false, readOnly: true, width: '80px', align: 'center' },
          { title: '労働無し', name: 'rodonashiFlg', type: 'checkbox', validateType: 'Free', validateLength: 50, required: false, readOnly: false, width: '80px' },
          { title: '補填時間', name: 'hotenTimeFormula', type: 'text', source: wkKasanJikyuKbnList, required: false, readOnly: false, width: '80px', align: 'center' },
          { title: '残業時間', name: 'ZangyoTimeFormula', type: 'text', source: wkKasanJikyuKbnList, required: false, readOnly: true, width: '80px', align: 'center' },
          { title: '早朝深夜', name: 'SochoShinyaTimeFormula', type: 'text', source: wkKasanJikyuKbnList, required: false, readOnly: true, width: '80px', align: 'center' }
        ]
      })
    },
    rowAppendAvobe: function (num) {
      this.rowAppend(num, true)
    },
    rowAppendBelow: function (num) {
      this.rowAppend(num, false)
    },
    rowAppend: function (num, aboveFlg, lastFlg) {
      // 現在の選択セル
      var activeC = this.$refs.ddSpreadSheet.getActiveCell()
      // 行追加先の位置を取得
      var pos = 0
      // 全選択状態なら先頭行に追加
      var isAllSelect = false
      if (!activeC) {
        // セル未選択
      } else if (activeC.length > 3) {
        // セル選択
        pos = Math.max(...[activeC[1], activeC[3]]) + 1

        // 全選択かどうか判定
        var isSame1 = activeC[0] === 0
        var isSame2 = activeC[1] === 0
        var isSame3 = activeC[2] === this.headers.length - 1
        var isSame4 = activeC[3] === this.rows.length - 1
        isAllSelect = isSame1 && isSame2 && isSame3 && isSame4
      }

      var tmpRow = []
      for (let i = 0; i < num; i++) {
        const newrow = {
          id: -1,
          sagyoKbn: null,
          sagyoKbnNm: null,
          jininId: null,
          shukkinHms: null,
          taikinHms: null
        }
        tmpRow.push(newrow)
      }
      // 行追加
      if (lastFlg !== undefined && lastFlg) {
        this.viewsData.vwKintaiJisseki.push(tmpRow)
        this.viewsData.vwKintaiJisseki.splice()
      } else {
        if (isAllSelect || (aboveFlg !== undefined && aboveFlg)) {
          if (pos === 0) {
            this.viewsData.vwKintaiJisseki.unshift(tmpRow)
          } else {
            this.viewsData.vwKintaiJisseki.splice(pos - 1, 0, tmpRow)
          }
        } else {
          this.viewsData.vwKintaiJisseki.push(tmpRow)
          this.viewsData.vwKintaiJisseki.splice()
        }
      }
    },

    onDummyFunction: function () {
    }
  }
}
